// extracted by mini-css-extract-plugin
module.exports = {"social-media":"SocialLinks_social-media__6Dyqu"};